import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { User } from '../user';

export interface AuthState {
   user: User;
   token: string;
   isLoggedIn: boolean;
   isLoggingIn: boolean;
   isRegistering: boolean;
}

function createInitialState(): AuthState {
  return {
    user: null,
    token: null,
    isLoggedIn: false,
    isLoggingIn: false,
    isRegistering: false
  } as any;
}

@Injectable()
@StoreConfig({ name: 'auth', resettable: true })
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialState());
  }
}

